import type { FaireProductEntity } from "../../entity_types/product";

export const p_67f3hdsyyv: FaireProductEntity = {
  token: "p_67f3hdsyyv",
  type: "product",
  name: "Waffle Knit Open Front Cardigan",
  brandToken: "b_aikxxfpecb",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/4c337956852ade83ff304871017855a24062c7354a0e2c9a27dee3e2f9dd3317.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/390ef59b91d56e4ecb80791f91099ac31a907d75ea5b1c66c67042db6d4cac65.jpeg",
    "https://cdn.faire.com/fastly/913a67af66a29e96a793d0cfea34ea2feeefd855062f419b30c3dbaf433ea11b.jpeg",
    "https://cdn.faire.com/fastly/279160bcf0d57e9372d730f5a5ce285b9a61b6935d4b0fb2cc919f08de0ed846.jpeg",
  ],
  priceDollars: 30,
  description:
    "Comfy waffle knit cardigan with a cozy, textured vibe. Versatile open front design for styling options. Relaxed fit for comfort and easy layering. This timeless cardigan is a must-have for in-between seasons.\n\nMaterial - 95%Polyester+5%Elastane\n",
  tags: [],
  msrpDollars: 60,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:27:31.516Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
